import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';
import Pin from 'Components/Map/Pin';
import { isEmpty } from 'lodash-es';
import { useEffect, useMemo, useState } from 'preact/hooks';
import { connect } from 'react-redux';

import { selectHabitat } from '../../../routes/map/actions';
import style from './style.scss';

const MapPin = ({
  pinRefs,
  onClick,
  smallPin,
  activeHabitatId,
  isFree,
  habitat: {
    _id,
    animal,
    isStreamOn,
    liveTalk,
    profileImage,
    disabled,
    label,
    mapPosition: { top, left },
  },
  delay,
  selectHabitatAction,
}) => {
  const [isVisible, setIsVisible] = useState(!delay);
  const [showHabitatTooltip, setShowHabitatTooltip] = useState(false);
  const showTalk = useMemo(() => isStreamOn && liveTalk && !showHabitatTooltip, [isStreamOn, liveTalk, showHabitatTooltip]);
  const showFree = useMemo(
    () => isStreamOn && !showTalk && isFree && !showHabitatTooltip,
    [showTalk, isStreamOn, isFree, showHabitatTooltip],
  );
  // eslint-disable-next-line max-len
  const showLabel = useMemo(
    () => !showTalk && !showFree && !isEmpty(label) && !showHabitatTooltip,
    [showTalk, showFree, label, showHabitatTooltip],
  );

  useEffect(() => {
    let timeout;
    if (delay && !isVisible) {
      timeout = setTimeout(() => setIsVisible(true), delay);
    }
    return () => clearTimeout(timeout);
  }, [delay, isVisible]);

  const habitatClickHandler = (evt, _id) => {
    evt.stopPropagation();
    if (onClick) {
      onClick(_id);
    } else {
      selectHabitatAction(_id);
    }
  };

  return (
    <div
      id={_id}
      // eslint-disable-next-line no-return-assign,no-param-reassign
      ref={(elm) => (pinRefs.current[_id] = elm)}
      style={{ top: `${top}%`, left: `${left}%` }}
      className={clsx(style.habitat, {
        [style.liveTalk]: liveTalk,
        [style.offline]: !isStreamOn,
        [style.disabled]: disabled,
        [style.small]: smallPin,
        [style.hovered]: showHabitatTooltip,
        [style.animateFadeIn]: isVisible,
      })}
      onClick={(evt) => habitatClickHandler(evt, _id)}
    >
      <div
        data-testid="habitat-pin"
        className={clsx(style.pinWrapper, { [style.bounce]: showTalk || _id === activeHabitatId })}
      >
        {showTalk && (
          <div
            className={clsx(style.label, style.largeLabel, {
              [style.offlineLabel]: !isStreamOn,
              [style.onlineLabel]: isStreamOn,
            })}
          >
            <FontAwesomeIcon icon={faCircle} />
            EVENT
          </div>
        )}
        {showFree && (
          <div
            className={clsx(style.label, style.largeLabel, {
              [style.offlineLabel]: !isStreamOn,
              [style.onlineLabel]: isStreamOn,
            })}
          >
            FREE
          </div>
        )}
        {showLabel && (
          <div
            className={clsx(style.label, {
              [style.offlineLabel]: !isStreamOn,
              [style.onlineLabel]: isStreamOn,
            })}
          >
            {label}
          </div>
        )}
        {showHabitatTooltip && (
          <div
            className={clsx(style.label, style.habitatLabel, {
              [style.offlineLabel]: !isStreamOn,
              [style.onlineLabel]: isStreamOn,
            })}
          >
            {animal}
          </div>
        )}
        <div
          className={clsx(style.pin, {
            [style.online]: isStreamOn,
            [style.offline]: !isStreamOn,
            [style.disabled]: disabled,
          })}
          onMouseEnter={() => setShowHabitatTooltip(true)}
          onMouseLeave={() => setShowHabitatTooltip(false)}
        >
          <img
            src={profileImage}
            alt="Habitat"
            data-title={animal}
            data-livealk={liveTalk}
            data-onlinehabitat={isStreamOn && !liveTalk}
            data-offlinehabitat={!liveTalk && !isStreamOn}
            className={clsx(style.profile, { [style.small]: smallPin })}
          />
          <Pin width={smallPin ? 60 : 80} />
        </div>
      </div>
    </div>
  );
};

export default connect(null, { selectHabitatAction: selectHabitat })(MapPin);
